module.exports = "/assets/e04a07923b6b577c2e6dc011083abc4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/F9.png
// module id = 2488
// module chunks = 0